<template>
    <ul id="xtkdTop">
        <li @click="clickItem(item)" :class="{ active: item.id == active }" v-for="(item, index) in items">
            
            <Badge v-if="false" :count="item.num">{{ item.name }} </Badge>
            {{ item.name }}<!-- ({{ item.num }}) -->
        </li>
        <li style="margin-left: auto;"><slot></slot></li>
    </ul>
</template>

<script>
export default {
    data() {
        return {
            items: [
                {
                    id: -1,
                    name: '全部',
                    num:10
                },
                {
                    id: 1,
                    name: '未送审',
                    num:10
                },
                {
                    id: 2,
                    name: '待审核',
                    num:4
                },
                {
                    id: 3,
                    name: '已驳回',
                    num:2
                }
            ],
            active: -1
        }
    },
    methods: {
        clickItem(item) {
            if (this.active==item.id) {
                return;
            }
            this.active = item.id;
            this.$emit('now',item.id)
        }
    },
   
}
</script>
<style>
#xtkdTop {
    display: flex;
    margin-bottom: 10px;
}
#xtkdTop li {
    padding: 4px 10px;
    cursor: pointer;
}
#xtkdTop li.active {
    border-bottom: solid 2px #333;
}
</style>


// WEBPACK FOOTER //
// src/components/wuliu/fahuo/xtkddTop.vue